<template>
  <div class="app-signup-one-time-pass-pane">
    <sub-header-section :pageTitle="$tc('SignupPage.OneTimePassPage.title')" backLink="/login" />

    <div class="app-signup-one-time-pass-pane__main">
      <one-time-pass-input-section
        oneTimePassScreen="AppSignup"
        @handlerSubmit="setOneTimePassPlanAndOnSubmit"
      />

      <p class="app-signup-one-time-pass-pane__message">
        {{ $tc('SignupPage.OneTimePassPage.memo') }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import OneTimePassInputSection from '@/components/MypageOneTimePassInputPage/OneTimePassInputPane/OneTimePassInputSection.vue'
import CouponDocument from '@/store/stores/collectionModule/documents/coupon/CouponDocument'
import MessageDialogStore from '@/store/stores/pageStore/common/MessageDialogStore'
import I18n from '@/locales/I18n'
import StoreUtil from '@/store/StoreUtil'

/**
 * アプリ新規会員登録: ワンタイムパス登録ペインのコンポーネント
 */
export default defineComponent({
  name: 'AppSignupOneTimePassPane',
  components: { OneTimePassInputSection, SubHeaderSection },
  setup() {
    const oneTimePassPageStore = StoreUtil.useStore('OneTimePassPageStore')
    const { oneTimePass, setOneTimePassPlan, getCouponPlan } = oneTimePassPageStore

    return {
      oneTimePass,
      setOneTimePassPlan,
      getCouponPlan,
    }
  },
  methods: {
    /**
     * ワンタイムパス登録ボタン押下時以下の処理を行う
     * 1. 取得したワンタイムパスのプラン情報をストアに保存
     * 2. 確認画面に遷移するための通知を親コンポーネントに伝える
     */
    async setOneTimePassPlanAndOnSubmit(oneTimePass: CouponDocument) {
      /** ワンタイムパスのプラン情報を取得 */
      const originalOneTimePassPlan = oneTimePass?.plans
        ? this.getCouponPlan(oneTimePass.plans)
        : null
      if (!originalOneTimePassPlan) {
        await MessageDialogStore.value.open({
          title: I18n.tc(
            'SignupPage.AppSignupOneTimePassPage.errors.getOneTimePassPlanError.title',
          ),
          message: I18n.tc(
            'SignupPage.AppSignupOneTimePassPage.errors.getOneTimePassPlanError.message',
          ),
        })
        // ワンタイムパスのプラン情報が取得できない場合、画面遷移しない
        return
      }

      // 取得したワンタイムパスをストアに格納
      this.oneTimePass = oneTimePass
      // 取得したワンタイムパスのプラン情報を元に画面表示用のワンタイムパスプラン情報を作成し、ストアに保存
      this.setOneTimePassPlan(originalOneTimePassPlan, oneTimePass)

      /** 確認画面への遷移 */
      this.$emit('handlerSubmit')
    },
  },
})
</script>

<style scoped lang="scss">
.app-signup-one-time-pass-pane {
  color: $gray75;
  background-color: $gray1;

  &__main {
    max-width: 480px;
    height: calc(100svh - 48px - 44px);
    padding: 80px 0;
    margin: 0 auto;
    overflow-y: auto;
    text-align: center;

    ::v-deep {
      .mypage-one-time-pass-input-section__title {
        color: $gray75;
      }
    }
  }

  &__message {
    padding: 0 16px;
    margin-top: 24px;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.53;
    letter-spacing: 0.04em;
  }
}
</style>
